import { useState, useEffect, useMemo } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";
import Login from "../login/Login";
import TopNavbar from "./topNavbar";
import EmployeeMasterList from "../employeeMaster/employeeMasterList";
import EditEmployeeMaster from "../employeeMaster/editEmployeeMaster";
import EquipmentsMasterList from "../equipmentsMaster/equipmentsMasterList";
import EditEquipmentsMaster from "../equipmentsMaster/editEquipmentsMaster";
import TestMasterList from "../testMaster/testMasterList";
import EditTestMaster from "../testMaster/editTestMaster";
import DisciplineMasterList from "../disciplineMaster/disciplineMasterList";
import EditDisciplineMaster from "../disciplineMaster/editDisciplineMaster";
import EditUserMaster from "../userMaster/editUserMaster";
import UserMasterList from "../userMaster/userMasterList";
import JobRegisterList from "../jobRegister/jobRegisterList";
import EditJobRegister from "../jobRegister/editJobRegister";
import EditUnitMaster from "../unitMaster/editUnitMaster";
import UnitMasterList from "../unitMaster/unitMasterList";
import MarkAttendanceModal from "../markAttendance/markAttendanceModal ";
import AttendanceList from "../markAttendance/attendanceList";
import ApplyLeaveUI from "../leave/applyLeave";
import EditInward from "../inward/editInward";
import InwardList from "../inward/inwardList";
import EditClientMaster from "../clientMaster/editClientMaster";
import ClientMasterList from "../clientMaster/clientMasterList";
import LeaveReport from "../leave/leaveReport";

import EditHoliday from "../holiday/editHoliday";
import HolidayList from "../holiday/HolidayList";
import InwardView from "../inward/print/inwardView";
import RBCAMasterList from "../rbac/RBCAMasterList";
import EditRBCAMaster from "../rbac/editRBCAMaster";
import DashBoard from "../dashboard/dashBoard";
import SchedularPrint from "../inward/print/schedular/schedularView";
import EmployeeView from "../employeeMaster/employeeView";
import { userTypes } from "../../utils/commonComponent/userConstant";
import DatasheetTemplateList from "../datasheetTemplate/templateList";
import Template from "../datasheetTemplate/template";
import DatasheetList from "../datasheet/datasheetList";
import EditDatasheet from "../datasheet/editDatasheet";
import ViewDatasheet from "../datasheet/datasheetPrint/viewDatasheet";
import CertificateList from "../certificates/certificateList";
import ViewCertificate from "../certificates/viewCertificate";
import RemarkList from "../remark/remarkList";
import EditRemark from "../remark/editRemark";
import SettingList from "../settings/settingList";
import EditSetting from "../settings/editSetting";
import TemplateList from "../template/templateList";
import EditTemplate from "../template/editTemplate";
import AppInfo from "../help/appinfo";
import Help from "../help/help";
import SummaryReport from "../Report/summaryReport/summaryReport";
import ProgressReport from "../Report/progressRpeort/progressReport";
import AttendanceRegularizationList from "../AttendanceRegularization/attendanceRegularizationList";
import EditAttendanceRegularization from "../AttendanceRegularization/editAttendanceRegularization";
import LeaveBalanceReport from "../leave/leaveBalanceReport";
import EmployeeCalendar from "../employeeMaster/employeeCalendar";
import RequirementList from "../requirement/requirementList";
import EditRequirement from "../requirement/editRequirement";
import RequirementView from "../requirement/requirementView";
import RequirementReport from "../requirement/requirementReport";
import LeaveRegularizationList from "../LeaveRegulation/leaveRegulationList";
import EditleaveRegularization from "../LeaveRegulation/editLeaveRegulation";
import ApprovalStatusReport from "../Report/approvalStatusReport/approvalStatusReport";
import InwardCSRFView from "../inward/print/inwardCSRF/inwardCSRFView";

const Main = (props) => {
 const location = useLocation();
  // Check if current route is a public print route (no login needed)
  const isPublicPrintRoute = location.pathname.startsWith("/certificate/print/");

  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [anchorEl, setAnchorEl] = useState(null);
 

  // Check if user is logged in
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn")
  );
  let username = sessionStorage.getItem("logInUser") || "";
  const _userType = Number(localStorage.getItem("type"));
  const userTypeLabel = userTypes.find(u => u.id === Number(_userType))?.label;

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      if (mobile !== isMobile) {
        setIsMobile(mobile);
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(false);
        } else {
          setSidebarOpen(true);
        }
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  // Memoize the Routes to prevent re-rendering when sidebar state changes
  const memoizedRoutes = useMemo(
    () => (
      <Routes>
        <Route index element={<DashBoard moduleId={1} />} />
        <Route path="/dashboard" element={<DashBoard moduleId={1} />} />

        <Route path="/master/employeeMaster" element={<EmployeeMasterList moduleId={51} />} />
        <Route path="/master/employeeMasterEdit/:id" element={<EditEmployeeMaster moduleId={51} />} />
        <Route path="/master/employeeMasterPrint/:id" element={<EmployeeView moduleId={51} />} />
         <Route path="/master/employeeCalendar/:id" element={<EmployeeCalendar moduleId={51} />} />

        <Route path="/master/masterEquipment" element={<EquipmentsMasterList moduleId={52} />} />
        <Route path="/master/editMasterEquipment/:id" element={<EditEquipmentsMaster moduleId={52} />} />

        <Route path="/master/testMaster" element={<TestMasterList moduleId={54} />} />
        <Route path="/master/editTestMaster/:id" element={<EditTestMaster moduleId={54} />} />

        <Route path="/master/discipline" element={<DisciplineMasterList moduleId={53} />} />
        <Route path="/master/editDiscipline/:id" element={<EditDisciplineMaster moduleId={53} />} />

        <Route path="/master/usersList" element={<UserMasterList moduleId={58} />} />
        <Route path="/master/editUser/:id" element={<EditUserMaster moduleId={58} />} />

        <Route path="/master/remarkList" element={<RemarkList moduleId={60} />} />
        <Route path="/master/editRemark/:id" element={<EditRemark moduleId={60} />} />

        <Route path="/master/settingList" element={<SettingList />} />
        <Route path="/master/editSetting/:id" element={<EditSetting />} />

        <Route path="/jobRegister" element={<JobRegisterList moduleId={3} />} />
        <Route path="/editJobRegister/:id" element={<EditJobRegister moduleId={3} />} />
        <Route path="/editJobRegisterView/:id" element={<EditJobRegister moduleId={3} Print={true} />} />

        <Route path="/requirementList" element={<RequirementList moduleId={10} />} />
        <Route path="/editRequirement/:id" element={<EditRequirement moduleId={10} />} />
        <Route path="/requirementView/:id" element={<RequirementView moduleId={10} />} />
       <Route path="/requirementReport" element={<RequirementReport moduleId={81}  />} />


        <Route path="/master/unit" element={<UnitMasterList moduleId={55} />} />
        <Route path="/master/editUnit/:id" element={<EditUnitMaster moduleId={55} />} />

        <Route path="/attendance" element={<AttendanceList moduleId={101} />} />
        <Route path="/attendanceRegularizationList" element={<AttendanceRegularizationList moduleId={102} />} />
        <Route path="/editAttendanceRegularization/:id" element={<EditAttendanceRegularization moduleId={102} />} />
      
        <Route path="/leave/apply" element={<ApplyLeaveUI moduleId={91} />} />
        <Route path="/leave/edit/:id" element={<ApplyLeaveUI moduleId={91} />} />
        <Route path="/leave/report" element={<LeaveReport moduleId={92} />} />
        <Route path="/leave/balanceReport" element={<LeaveBalanceReport moduleId={93} />} />
        <Route path="/leave/leaveRegularization" element={<LeaveRegularizationList moduleId={94} />} />
        <Route path="/leave/editleaveRegularization/:id" element={<EditleaveRegularization moduleId={94} />} />

        <Route path="/master/client" element={<ClientMasterList moduleId={57} />} />
        <Route path="/master/editClient/:id" element={<EditClientMaster moduleId={57} />} />

        <Route path="/editInward/:id" element={<EditInward moduleId={4} />} />
        <Route path="/inwardList" element={<InwardList moduleId={4} />} />
        <Route path="/inwardPrint/:id" element={<InwardView moduleId={4} />} />
        <Route path="/inwardCSRFPrint/:id" element={<InwardCSRFView moduleId={4} />} />
        <Route path="/schedularPrint/:id" element={<SchedularPrint moduleId={4} />} />

        <Route path="/master/rbacList" element={<RBCAMasterList />} />
        <Route path="/master/editRBCA/:id" element={<EditRBCAMaster />} />

        <Route path="/master/holiday" element={<HolidayList moduleId={56} />} />
        <Route path="/master/editHoliday/:id" element={<EditHoliday moduleId={56} />} />

        <Route path="/master/createDatasheetTemplate" element={<Template moduleId={63} />} />
        <Route path="/master/editDatasheetTemplate/:id" element={<Template moduleId={63} />} />
        <Route path="/master/datasheetTemplate" element={<DatasheetTemplateList moduleId={63} />} />

        <Route path="/master/templateList" element={<TemplateList moduleId={62} />} />
        <Route path="/master/editTemplate/:id" element={<EditTemplate moduleId={62} />} />

        <Route path="/datasheetList" element={<DatasheetList moduleId={7} rolesInfo={props?.rolesInfo} />} />
        <Route path="/editdatasheet/:id" element={<EditDatasheet moduleId={7} rolesInfo={props?.rolesInfo} />} />
        <Route path="/viewdatasheet/:id" element={<ViewDatasheet moduleId={7} rolesInfo={props?.rolesInfo} />} />

        <Route path="/certificateList" element={<CertificateList moduleId={8} rolesInfo={props?.rolesInfo} />} />
        <Route path="/viewCertificate/:id" element={<ViewCertificate moduleId={8} rolesInfo={props?.rolesInfo} />} />

        <Route path="/summaryReport" element={<SummaryReport moduleId={151}  />} />
        <Route path="/progressReport" element={<ProgressReport moduleId={152}  />} />
        <Route path="/approvalStatusReport" element={<ApprovalStatusReport moduleId={153}  />} />
        

        <Route path="/appinfo" element={<AppInfo />} />
        <Route path="/help" element={<Help />} />
      </Routes>
    ),
    [props?.rolesInfo]
  );

  // Render public print page directly — no login, no sidebar
  if (isPublicPrintRoute) {
    return (
      <Routes>
        <Route
          path="/certificate/print/:id"
          element={<ViewCertificate moduleId={8} />}
        />
      </Routes>
    );
  }

  return (
    <>
      {!isLoggedIn ? (
        <div className="min-h-screen w-full">
          <Routes>
            <Route path="*" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
          </Routes>
        </div>
      ) : (
        <div className="flex flex-col h-screen overflow-hidden">
          <TopNavbar
            rolesInfo={props?.rolesInfo}
            username={username}
            userTypeLabel={userTypeLabel}
            setIsLoggedIn={setIsLoggedIn}
            setSidebarOpen={setSidebarOpen}
            isSidebarOpen={isSidebarOpen}
          />

          <div className="flex flex-1 overflow-hidden relative">
            {/* Mobile Overlay */}
            {isMobile && isSidebarOpen && (
              <div
                className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
                onClick={() => setSidebarOpen(false)}
                style={{ top: "70px" }} 
              />
            )}

            {/* Sidebar */}
            <Sidebar
              isSidebarOpen={isSidebarOpen}
              setSidebarOpen={setSidebarOpen}
              isMobile={isMobile}
            />

  {/*      <div className="flex-1 overflow-y-auto p-4 sm:p-6 bg-slate-50">}

            {/* Main content area */}
            <div className="flex-1 overflow-y-auto p-4 pb-4 sm:px-6 sm:pb-6 bg-white">
              <div className="max-w-full">
                {memoizedRoutes}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Main;
